import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import { useAtomValue } from 'jotai';
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { adminDetailsJotaiAtom, teamsJotaiAtom } from '../jotai/atoms';
import { analytics } from '../utils/analytics';
import type { Params } from './Dashboard';
import { InviteDialog } from './InviteDialog';
import { UserProfile } from './UserProfile';

const styles = {
  bar: {
    paddingLeft: 2,
    paddingTop: 1,
    paddingBottom: 1,
    paddingRight: 4,
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderColor: 'divider',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  }
} as const;

/**
 * ダッシュボードの「管理者」タブ
 */
export function DashboardAdmins() {
  // 現在の管理者の UID
  const { teamId } = useParams<Params>();
  const admins = useAtomValue(teamsJotaiAtom(teamId))?.admins;

  // 管理者を招待する
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <Box sx={styles.bar}>
        <Typography variant="h6">管理者一覧</Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setOpen(true)}
        >
          管理者を招待する
        </Button>
        <InviteDialog
          teamId={teamId}
          open={open}
          onClose={(e, reason) => reason !== 'backdropClick' && setOpen(false)}
        />
      </Box>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>名前</TableCell>
            <TableCell>ハックフォープレイでのユーザー名</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {admins
            ? admins.map(uid => (
                <AdminRow key={uid} teamId={teamId} uid={uid} />
              ))
            : null}
        </TableBody>
      </Table>
    </>
  );
}

interface AdminRowProps {
  teamId: string;
  uid: string;
}

function AdminRow(props: AdminRowProps) {
  // 管理者の詳細
  const adminDetail = useAtomValue(adminDetailsJotaiAtom(props.teamId))[
    props.uid
  ];

  if (!adminDetail) {
    return null;
  }

  return (
    <TableRow>
      <TableCell>{adminDetail.name}</TableCell>
      <TableCell>
        <UserProfile uid={props.uid} />
      </TableCell>
      <TableCell align="right"></TableCell>
    </TableRow>
  );
}
